import $ from 'jquery'
import Slider from 'react-slick'
import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from '@reach/router'

const settingsSlick = {
  dots: false,
  infinite: true,
  items: 1,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

//Helpers
import { getCover, getPreviewSlider, getQuality } from '@helpers/helper.rendering'
import { getfavorites, checkFavorite, addFavorites } from '@helpers/helper.favorites'
import {
  getOperations,
  getType,
  getLocation,
  getRegion,
  getFakeAddres,
  getPrices,
  makeLink,
  getNameProducer,
  getPictureProducer,
} from '@helpers/helper.properties'

import toast from 'react-hot-toast'
import { updateRouter } from '@helpers/helper.filters'
import { addMarker } from '@helpers/helper.map'
import Loader from '@components/loader/1'
import {
  FiltersProperties,
  Photo,
  Property,
  RealEstateDataPageComponentData,
  StatePropertiesSlice,
  TokkoProducer,
} from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { changeSelectedAction, updateFavorites, updateFocusProperty } from '@slices/propertiesSlice'
import { useMap } from '@vis.gl/react-google-maps'
import { inherits } from 'util'
// import { useIconsType } from '@hooks/useIconsType'
interface Props {
  property: Property
  settings: any
  dispatch: any
  skeleton: boolean
  filters: FiltersProperties
  setZoom: any
  map: any
  handlerClick: any
  isLeaflet: boolean
  opacity: boolean
  inMap: boolean
  grid_map: boolean
  basic: boolean
  customOperation?: string
}

const Card_Property_2 = ({
  property,
  settings,
  skeleton,
  setZoom,
  handlerClick,
  isLeaflet,
  opacity,
  inMap,
  // map,
  grid_map,
  basic,
  global_data,
  customOperation,
}: Props & RealEstateDataPageComponentData) => {
  const icons = global_data?.pageConfig.design.icons || 'Solid'
  const { divisionPath } = global_data
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const backgroundSecondary = global_data.content.cardsProperties.data.backgroundSecondary
  const groupIds = global_data.content.cardsProperties.data.groupIds
  const groupName = global_data.content.cardsProperties.data.groupName
  const backgroundColor = global_data.content.cardsProperties.data?.backgroundColor
  const backgroundHexa = global_data.content.cardsProperties.data?.backgroundHexa
  const opacityGradient = global_data.content.cardsProperties.data?.opacityGradient
  const hidden = global_data.content.cardsProperties.data?.hidden

  const lowPrice = true
  const history = useLocation()

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))
  const sliderRef = useRef<any>()

  const { updaterFavorites, selected, filters } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const Producer_Module = !hidden

  const toastCheck = (id: number, fake_address: string) => {
    if (!checkFavorite(id.toString(), 'prop', 'template-site'))
      return toast.success(fake_address + ' agregada a tus favoritos')
    else return toast.success(fake_address + ' eliminada de tus favoritos')
  }

  const addHoverMap = (property: Property) => {
    $('#marker-' + property?.id).addClass(' hover-marker')
    $('#marker-' + property?.development?.id).addClass(' hover-marker')
  }

  const removeHoverMap = () => {
    $('#marker-' + property?.id).removeClass(' hover-marker')
    $('#marker-' + property?.development?.id).removeClass(' hover-marker')
  }

  const toggleModal = (boolean: boolean) => {
    document.body.classList.remove('modal-open')
    // const element = document.getElementById('exampleModal') as HTMLElement
    // element.remove()
    $('#exampleModal').hide()
    $('.modal-backdrop').hide()
    // const modal: any = document.getElementById('exampleModal')
    // modal.classList.remove('show')
    // modal.style.display = 'none'
    // document.body.classList.remove('modal-open')
    document.body.style.overflow = 'auto'
  }

  const createLinkProducer = (producer: TokkoProducer) => {
    let url = ''
    if (filters && updateRouter(filters, true, divisionPath)) {
      const splitter = updateRouter(filters, true, divisionPath)
        ?.split('/')
        .filter((element: string) => !element?.includes('producer') && element !== '')!
      for (const iterator of splitter) {
        url += iterator + '/'
      }
      if (producer) {
        return (
          (divisionPath ?? '') +
          '/' +
          url +
          'producer-' +
          producer?.id +
          '-' +
          producer?.name
            ?.toLowerCase()
            .replaceAll(' ', '-')
            .replaceAll('.', '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        )
      }
    }
    if (history.pathname.toLowerCase().includes('alquiler')) {
      return (
        (divisionPath ?? '') +
        '/alquiler/' +
        url +
        'producer-' +
        producer?.id +
        '-' +
        producer?.name
          ?.toLowerCase()
          .replaceAll(' ', '-')
          .replaceAll('.', '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      )
    } else {
      return (
        (divisionPath ?? '') +
        '/venta/' +
        url +
        'producer-' +
        producer?.id +
        '-' +
        producer?.name
          ?.toLowerCase()
          .replaceAll(' ', '-')
          .replaceAll('.', '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      )
    }
  }

  useEffect(() => {
    setListFavorites(getfavorites('prop', 'template-site'))
  }, [updaterFavorites])

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const dispatch = useDispatch()

  function valideActiveGroup() {
    if (groupIds?.find((group) => group.toString() === property.type.id.toString())) {
      return true
    }
    return false
  }

  return (
    <div
      onMouseEnter={() => addHoverMap(property)}
      onMouseLeave={() => removeHoverMap()}
      id={'card-grid-' + (grid_map && property?.id)}
      onClick={() => {}}
      className={
        'card prop b prop-card ' +
        (skeleton && ' skeleton ') +
        (inMap ? ' map-card ' : '') +
        (opacity ? ' opacity-card ' : '') +
        (grid_map ? ' grid-card  ' : '') +
        (backgroundSecondary ? ' theme-secondary ' : '')
      }
    >
      <div className={'card-image ' + (grid_map && 'grid_map_image')}>
        {skeleton && <Loader />}
        {basic ? (
          <a
            target="_blank"
            href={makeLink(property, divisionPath)}
          >
            <img
              src={skeleton ? '' : getQuality(getCover(property?.photos))}
              className="notScale"
              alt={'image propiedad'}
            />
          </a>
        ) : (
          property?.photos && (
            <>
              <Slider
                ref={sliderRef}
                {...settingsSlick}
                className="overflow-hidden card-carousel"
              >
                {getPreviewSlider(property?.photos).map((photo: Photo, index: number) =>
                  grid_map ? (
                    <a
                      target="_blank"
                      href={makeLink(property, divisionPath)}
                    >
                      <img
                        key={index}
                        src={index === 0 ? getQuality(photo) : getQuality(photo)}
                        className="notScale"
                        alt={'Imagen de tokkoBroker'}
                      />
                    </a>
                  ) : (
                    <a
                      key={index}
                      target={'_blank'}
                      href={makeLink(property, divisionPath)}
                    >
                      {
                        <img
                          src={index === 0 ? getQuality(photo) : getQuality(photo)}
                          className="notScale"
                          alt={'Imagen de tokkoBroker'}
                        />
                      }
                    </a>
                  ),
                )}
              </Slider>
              {getPreviewSlider(property?.photos)?.length > 1 && (
                <div className="arrows-owl minimal left">
                  <div
                    className="arrow"
                    onClick={() => sliderRef.current.slickPrev()}
                  >
                    {' '}
                    <i></i> <i></i>
                  </div>
                </div>
              )}
              {getPreviewSlider(property?.photos)?.length > 1 && (
                <div className="arrows-owl minimal right">
                  <div
                    className="arrow reverse"
                    onClick={() => sliderRef.current.slickNext()}
                  >
                    {' '}
                    <i></i> <i></i>{' '}
                  </div>
                </div>
              )}
            </>
          )
        )}
        <div className="badges">
          {/* Operation */}
          {property ? (
            getOperations(property).map((operation: string, index: number) => (
              <div
                key={index}
                className={'fst-italic badge ' + operation.toLowerCase()}
              >
                {operation}
              </div>
            ))
          ) : (
            <div className={'fst-italic badge '}>XXXXX</div>
          )}
          {/* Type */}
          {getType(property)?.length > 0 ? (
            <div className="fst-italic badge property-type">
              {valideActiveGroup() ? groupName : getType(property)}
            </div>
          ) : (
            <div className={'fst-italic badge '}>XXXXX</div>
          )}
        </div>
        <div
          onClick={() => toggleModal(false)}
          className="close-card"
        >
          <i></i>
          <i></i>
        </div>
        <span
          onClick={() => {
            toastCheck(property?.id, property?.fake_address)
            addFavorites(property?.id.toString(), 'prop', 'template-site')
            dispatch(updateFavorites())
          }}
          className={
            `d-lg-inline-flex icon-favoritos-heart${
              listFavorites.find(
                (element: string) => element?.toString() === property?.id?.toString(),
              )
                ? '-solid'
                : iconsStyle
            } btn fav ` +
            (listFavorites.find(
              (element: string) => element?.toString() === property?.id?.toString(),
            )
              ? 'active'
              : '')
          }
          style={{ zIndex: '19', fontStyle: 'normal !important' }}
        ></span>
      </div>
      <div
        onClick={() => {
          addMarker(property.id)!
          selected !== property.id
            ? dispatch(updateFocusProperty(property.id))
            : dispatch(updateFocusProperty(null))
          selected !== property.id
            ? dispatch(changeSelectedAction(property.id))
            : dispatch(changeSelectedAction(null))
        }}
        className={'card-body ' + (grid_map && 'grid-card-body')}
      >
        <div className={'content-extra row align-items-center '}>
          <div className={grid_map ? 'col-12' : 'col-12'}>
            <div className="row">
              {/* Productor */}
              {Producer_Module && property?.producer ? (
                <div className={(grid_map ? 'col-7' : 'col-12') + ' div-productor-card'}>
                  <a
                    className={`productor-data d-flex align-items-center px-0 pb-3 ${
                      grid_map ? 'pb-lg-2' : ''
                    }`}
                  >
                    {getPictureProducer(property) ? (
                      <img
                        src={getPictureProducer(property)}
                        alt={getNameProducer(property)}
                        className="notScale productor-img object-fit-cover rounded-5 me-3"
                      />
                    ) : null}
                    {getNameProducer(property) ? (
                      <div className="productor-text d-flex flex-column">
                        <span className="product-contact text-uppercase m-0">Contacto</span>
                        <span className="product-name m-0">{getNameProducer(property)}</span>
                      </div>
                    ) : null}
                  </a>
                </div>
              ) : null}
              {/* Title */}
              <h4
                className={`card-title my-3 col-12 text-uppercase
                    ${grid_map ? ' my-lg-2 mt-lg-3 ' : ''}`}
              >
                {!grid_map ? (
                  <div style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                    {getFakeAddres(property)}
                  </div>
                ) : (
                  <div style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                    {getFakeAddres(property)}
                  </div>
                )}
              </h4>
              {/* Location */}
              <div className="col-12">
                <p className={`location-text pb-3 text-uppercase ${grid_map ? ' ' : ''}`}>
                  <i className="icon-location me-1"></i>
                  {getLocation(property)}, {getRegion(property)}
                </p>
              </div>
              {/* Details */}
              <div className="col-12">
                <div
                  className={`details d-flex align-items-center justify-content-start mb-3 ${
                    grid_map ? 'mx-lg-2 mb-lg-1' : ''
                  }`}
                >
                  {property?.roofed_surface ? (
                    <div className="details-item d-flex justify-content-center align-items-center py-1 me-2 pe-3">
                      <i className="icon-measure-light me-lg-2 ms-2 me-1"></i>
                      {Intl.NumberFormat('de-DE').format(Number(property.roofed_surface))} m2
                    </div>
                  ) : null}
                  {property?.suite_amount ? (
                    <div className="details-item d-flex justify-content-center align-items-center py-1 me-2 pe-3 me-3">
                      <i className="icon-rooms-light me-lg-2 ms-2 me-1"></i>
                      {property?.suite_amount}
                    </div>
                  ) : null}
                  {property?.bathroom_amount ? (
                    <div className="details-item d-flex justify-content-center align-items-center py-1 me-2 pe-3 me-3">
                      <i className="icon-bathroom-light me-lg-2 ms-2 me-1"></i>
                      {property.bathroom_amount}
                    </div>
                  ) : null}
                  {property?.parking_lot_amount ? (
                    <div className="details-item d-flex justify-content-center align-items-center py-1 me-2 pe-3 me-3">
                      <i className="icon-parking-light me-lg-2 ms-2 me-1"></i>
                      {property.parking_lot_amount}
                    </div>
                  ) : null}
                </div>
              </div>
              {/* Price */}
              <div
                className={
                  'align-items-center-end justify-content-between d-flex mt-2 ' +
                  (grid_map ? 'mt-lg-3' : 'mt-lg-0')
                }
              >
                {skeleton ? (
                  <div className="d-block mt-2 mt-lg-2">
                    <h3 className={'prop-price mb-1 '}>
                      <div className="d-flex align-items-center">
                        <div className={'previous align-items-center me-3 d-flex '}>
                          {' '}
                          <div className="inline-block text-through">XX XXX</div>{' '}
                        </div>
                      </div>
                    </h3>
                    <h3 className={'prop-price me-3 mb-0 '}>
                      <div className="d-flex align-items-center">
                        <div>XXXX XXXXXXX</div>
                        {<small className="ms-2"> XXXXX</small>}
                      </div>
                    </h3>
                  </div>
                ) : (
                  getPrices(property).map((price, index) => (
                    <div
                      key={index}
                      className={
                        customOperation?.toLowerCase() === price.type.toLowerCase() ||
                        price.type.toLowerCase().replaceAll(' ', '-') ===
                          filters?.operation?.toLowerCase().replaceAll(' ', '-') ||
                        (price.type.includes('temporario') && filters.operation === 'temporario')
                          ? 'd-block '
                          : 'd-none '
                      }
                    >
                      <h5 className={'prop-price mb-1 ' + price.type + (lowPrice ? '' : ' d-none')}>
                        <div className="d-flex align-items-center">
                          <div
                            className={
                              'previous align-items-center me-3 ' +
                              (price.is_less_than_previous_price ? 'd-flex' : 'd-none')
                            }
                          >
                            {' '}
                            <div className="inline-block text-through">
                              {price.currency}{' '}
                              {price?.previous_price! > 0
                                ? Intl.NumberFormat('de-DE').format(price?.previous_price!)
                                : price.previous_price}{' '}
                            </div>{' '}
                            <i className="icon-arrow_down"></i>{' '}
                          </div>
                        </div>
                      </h5>
                      <h5 className={'prop-price me-3 mb-0 ' + price.type}>
                        <div className="d-flex align-items-center">
                          <div style={{ fontSize: 'inherit' }}>
                            {price.currency}{' '}
                            {typeof price.price === 'number'
                              ? Intl.NumberFormat('de-DE').format(price.price)
                              : price.price}
                          </div>
                          {price.period ? <small className="ms-2"> ( {price.period}) </small> : ''}
                        </div>
                      </h5>
                    </div>
                  ))
                )}
                {!skeleton && (
                  <a
                    className={'read-more ' + (opacityGradient ? 'is-fill' : '')}
                    target={'_blank'}
                    style={{
                      background: opacityGradient ? backgroundColor : '',
                      color: opacityGradient ? backgroundHexa : '',
                    }}
                    href={makeLink(property, divisionPath)}
                  >
                    Ver más
                  </a>
                )}
              </div>
              {/* Expenses */}
              <div className="block">
                {getPrices(property).map((price, index) => (
                  <h3
                    key={index}
                    className={'prop-price me-3 mb-0 ' + price.type}
                  >
                    {property.expenses !== 0 && index === 0 && (
                      <span>
                        {/* <br /> */}
                        EXP: ARS {Intl.NumberFormat('de-DE').format(property.expenses)}
                      </span>
                    )}
                  </h3>
                ))}
              </div>
              {/* Read more link */}
              {/* <a
                  className="read-more fst-italic"
                  target={'_blank'}
                  href={makeLink(property, divisionPath)}
                >
                  Ver más
                </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card_Property_2
